import { Button, Input, Radio, RadioChangeEvent } from 'antd';
import RadioBtn from '../../Common/Form/RadioBtn';
import { _FORM_ITEM_LAYOUT, _TAIL_FORM_ITEM_LAYOUT } from '../../../constants';
import { FormItemsWrapper, OtherSurgeriesWrapper, StyledForm } from './style';
import { useState } from 'react';
import { AddMoreBtnContainer } from '../../Common/Button/style';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

const SurgeriesForm = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);
  const [form] = StyledForm.useForm();
  const [withSurgeries, setWithSurgeries] = useState<boolean>(Boolean(selectedClient?.surgeries) ?? false);

  const onFinish = (values: any) => {
    console.log('Received values of form: ', values);
  };

  const onChangeWithVaccination = ({ target: { value } }: RadioChangeEvent) => {
    setWithSurgeries(value);
  };

  const onRemoveSurgery = (fieldIndex: any) => {
    const oldSurgeries = form.getFieldValue('surgeries') || [];
    const newSurgeries = oldSurgeries.map((item: any, index: number) =>
      index === fieldIndex ? { ...item, _destroy: true } : item
    );
    form.setFieldsValue({ surgeries: newSurgeries });
  };

  return (
    <StyledForm
      {..._FORM_ITEM_LAYOUT}
      form={form}
      name="surgeries_form"
      onFinish={onFinish}
      initialValues={{ surgeries: selectedClient?.surgeries }}
      style={{ marginTop: '1rem' }}
      scrollToFirstError
    >
      <p>Have you had any surgeries?</p>
      <Radio.Group
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
        onChange={onChangeWithVaccination}
        value={withSurgeries}
        optionType="button"
        buttonStyle="solid"
      />
      {withSurgeries && (
        <FormItemsWrapper>
          <StyledForm.List name="surgeries">
            {(fields, { add, remove }) => (
              <>
                {fields
                  .filter(({ name }) => {
                    const surgeries = form.getFieldValue('surgeries') || [];
                    const fieldData = surgeries[name];
                    return !fieldData?._destroy;
                  })
                  .map((field: any, index: number) => (
                    <OtherSurgeriesWrapper>
                      <div className="number-container">
                        <p>{`${++index})`}</p>
                        <Button
                          size="small"
                          onClick={() => {
                            // remove(field.name);
                            onRemoveSurgery(field.name);
                          }}
                        >
                          Remove
                        </Button>
                      </div>
                      <StyledForm.Item
                        name={[field.name, 'forWhat']}
                        label="For what?"
                        labelAlign="left"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field!',
                          },
                        ]}
                      >
                        <Input />
                      </StyledForm.Item>
                      <StyledForm.Item
                        name={[field.name, 'when']}
                        label="When?"
                        labelAlign="left"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field!',
                          },
                        ]}
                      >
                        <Input />
                      </StyledForm.Item>
                    </OtherSurgeriesWrapper>
                  ))}
                <AddMoreBtnContainer>
                  <Button
                    size="small"
                    onClick={() => add()}
                  >
                    Add more
                  </Button>
                </AddMoreBtnContainer>
              </>
            )}
          </StyledForm.List>
        </FormItemsWrapper>
      )}
      <StyledForm.Item {..._TAIL_FORM_ITEM_LAYOUT}>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </StyledForm.Item>
    </StyledForm>
  )
}

export default SurgeriesForm;